<template>
  <div class="order">
    <fixed-header :title="fromJifen ? '兑换记录' : '我的订单'"></fixed-header>
    <div class="order__main">
      <div class="order__nav">
        <div
            v-for="(item, index) in ORDER_TYPE_OPTIONS"
            :key="index"
            :class="[nowType === item.value ? 'order__checked-nav' : '']"
            @click="changeNowType(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
      <div
          v-infinite-scroll="loadMore"
          :infinite-scroll-disabled="loading"
          :infinite-scroll-distance="30"
          class="order__content scroll-touch"
      >
        <img
            v-if="!orders.length"
            :src="order_null"
            alt=""
            class="order__content-background"
        />
        <div
            v-for="(item, index) in orders"
            v-else
            :key="index"
            class="order__content-item"
        >
          <section class="order__content-ordersn">
            <span>{{ item.orderSn }}</span>
            <span>{{ getOrderStatusTitle(item) }}</span>
          </section>
          <section
              :mg-stat-custom="`cont=${item.orderId}&label=order&direct=cntp&addr=haowu_order_detail`"
              class="order__content-goods"
              mg-stat-click
              @click="gotoDetail(item)"
          >
            <div
                v-for="(ele, index2) in item.orderGoodsList"
                :key="index2"
                class="order__content-sku"
            >
              <div class="order__content-skuimg">
                <img :src="ele.originalImg" alt=""/>
              </div>
              <div class="order__content-skuinfo">
                <section>
                  <p>{{ ele.goodsName }}</p>
                  <p v-if="item.promType != 10">{{ getGoodsPrice(ele) }}</p>
                  <p v-else>{{ item.entry }}</p>
                </section>
                <section>
                  <p @click="gotoReturnInfo(ele)">{{ getOrderRefundTitle(ele) }}</p>
                  <p>{{ ele.specKeyName }}</p>
                </section>
                <p v-if="item.promType === 4" class="order__presell-logo">
                  <i class="icon presell_logo"></i>
                </p>
                <p v-if="isPayDeposit(item.orderStatusCode)">
                  {{
                    dateFormater(
                        item.preSellInfo.retainageStart * 1000,
                        'MM-dd hh:mm'
                    )
                  }}
                  开始支付尾款
                </p>
                <p v-if="isNotPayEndPrice(item.orderStatusCode)">
                  {{ getEndPriceLabel(item.preSellInfo) }}
                </p>
                <section v-if="deliveryInPart(item, ele)">
                  <button
                      :mg-stat-custom="`cont=查看物流&label=btn&direct=web&addr=haowu_express`"
                      :mg-stat-lob="`order_id=${item.orderId}`"
                      class="opt-button"
                      mg-stat-click
                      @click.stop="gotoExpress(item, ele.deliveryId)"
                  >
                    查看物流
                  </button>
                </section>
              </div>
            </div>
          </section>
          <section
              v-if="!isNotPayEndPrice(item.orderStatusCode)"
              class="order__content-price"
          >
            <span>共{{ countGoodsNum(item) }}件商品</span>
            <span v-if="item.promType!=10">合计：{{ getOrderAmount(item) }}</span>
            <span v-if="showShipping(item.shippingPrice)"
            >(含运费:￥{{ item.shippingPrice }})</span
            >
          </section>
          <div
              v-if="isNotPayEndPrice(item.orderStatusCode)"
              :mg-stat-lob="`order_id=${item.orderId}`"
              class="order__presell-buy"
              mg-stat-click
              mg-stat-custom="label=btn&cont=付尾款&direct=cntp&addr=w_pay"
              @click="gotoPay(item)"
          >
            <pre-buy-button
                :price="item.orderAmount"
                :time="item.preSellInfo.retainageEnd * 1000"
            ></pre-buy-button>
          </div>
          <section v-if="getOptButton(item)&&getOptButton(item).length" class="order__content-buy">
            <button
                v-for="(ele, index2) in getOptButton(item)"
                :key="index2"
                :class="[ele.title === '付款' ? 'pay_class' : '']"
                :mg-stat-custom="`cont=${ele.title}&direct=cntp&label=btn`"
                :mg-stat-lob="`order_id=${item.orderId}`"
                class="opt-button"
                mg-stat-click
                @click="ele.method(item)"
            >
              {{ ele.title }}
            </button>
          </section>
        </div>
        <page-loading v-if="loading"></page-loading>
      </div>
    </div>
    <Pay
        :crowdId="crowdId"
        :isShow="isShowPay"
        :oldOrderId="oldOrderId"
        :orderId="orderId"
        :payCode="payCode"
        :price="orderPrice"
        :storeId="payStoreId"
        type="order_pay"
        @changeVisible="(val) => (isShowPay = val)"
        @clickPay="uploadClose"
    ></Pay>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FixedHeader from 'components/common/FixedHeader';
import PageLoading from 'components/common/PageLoading';
import RefundPicker from 'components/refund/RefundPicker';
import PreBuyButton from 'components/order/PreBuyButton';
import * as orderApi from 'apis/order';
import { dateFormater } from 'utils/date';
import { getOrderRefundTitle, getOrderStatusTitle, isNotPayEndPrice, isPayDeposit } from 'utils/order';
import { hideMessageBox } from 'utils';
import { beforeRouteChange, initCloseUpload, setFixedParams, uploadAccessData, uploadCloseData } from 'utils/uploadData';
import DataStorage from 'utils/dataStore';
import Pay from 'components/common/Pay';
import { getMgtvUserTicket, judgeLogin, setAsyncUserInfo } from 'utils/user';
import order_null from 'assets/img/order_null.png';
import MgtvApi from 'MgtvApi';
import MgStat from 'MgStat';
import _ from 'lodash';

export default {
  components: {
    FixedHeader,
    PageLoading,
    RefundPicker,
    Pay,
    PreBuyButton,
  },
  data() {
    const { type } = this.$route.query;
    return {
      order_null,
      nowType: type || 'ALL',
      orders: [],
      orderId: 0,
      crowdId: null,
      orderPrice: 0,
      payCode: '',
      pageNo: 0,
      loading: false,
      disableLoad: false,
      isChangeType: false,
      ORDER_TYPE_OPTIONS: [
        {
          value: 'ALL',
          label: '全部',
        },
        {
          value: 'WAITPAY',
          label: '待付款',
        },
        {
          value: 'WAITSEND',
          label: '待发货',
        },
        {
          value: 'WAITRECEIVE',
          label: '待收货',
        },
        {
          value: 'WAITCCOMMENT',
          label: '待评价',
        },
      ],
      isShowPay: false,
      nowOrderId: 0,
      hasAnyAction: false, // 是否有操作
      hasRouteChange: false,
      oldOrderId: null,
      cntp: '',
      storeId: 0,
      payStoreId: 0,
    };
  },
  computed: {
    ...mapState('homePage', ['fromSource']),
    fromJifen() {
      return this.fromSource == 'jifen_shop_home';
    },
    fromJubaopen() {
      return this.$route.query.from === 'jubaopen_shop_home';
    },
  },
  watch: {
    hasAnyAction: {
      handler(val) {
        DataStorage.setPageVisitiLog(val);
      },
      immediate: true,
    },
    nowType: {
      handler(val) {
        switch (val) {
          case 'WAITPAY':
            this.cntp = 'haowu_order_pay';
            break;
          case 'WAITSEND':
            this.cntp = 'haowu_order_send';
            break;
          case 'WAITRECEIVE':
            this.cntp = 'haowu_order_get';
            break;
          case 'WAITCCOMMENT':
            this.cntp = 'haowu_order_rated';
            break;
          default:
            this.cntp = 'haowu_order_all';
        }
        document
          .getElementsByTagName('body')[0]
          .setAttribute('mg-stat-page', `${this.cntp}`);
      },
      immediate: true,
    },
  },
  async created() {
    uploadAccessData();
    setTimeout(() => {
      const userInfo = getMgtvUserTicket();
      if (!(userInfo && userInfo.ticket)) {
        judgeLogin();
      }
    }, 500);
    await setFixedParams(this);
  },
  mounted() {
    initCloseUpload();
  },
  methods: {
    dateFormater,
    getOrderStatusTitle,
    getOrderRefundTitle,
    isPayDeposit,
    isNotPayEndPrice,
    getEndPriceLabel({ salePrice, preDiscountPirce }) {
      let str = `预售价¥${salePrice} `;
      if (Number(preDiscountPirce) > 0) {
        str += `尾款优惠 ￥${preDiscountPirce}`;
      }
      return str;
    },
    // 部分发货
    deliveryInPart(item, ele) {
      const {
        orderStatusCode: code, orderGoodsList, isPointOrder, orderStatus,
      } = item;
      const { deliveryId } = ele;
      if (
        code === 'WAITRECEIVE' ||
          code === 'WAITCCOMMENT' ||
          code === 'FINISH' ||
          code === 'PORTIONSEND'
      ) {
        // 如果该商品发了货 并且和其他商品配送id不一直  则认为是部分发货
        return (
          deliveryId && orderGoodsList.some(f => f.deliveryId !== deliveryId)
        );
      } else if (isPointOrder && orderStatus != 3 && orderStatus != 5 && orderGoodsList.some(f => !f.isVirtual)) {
        return true;
      }
      return false;
    },
    async uploadClose(callback) {
      this.hasRouteChange = true; // 支付成功回来之后 路由会变化 但是支付的时候已经上报了  所以设置为true 不再上报
      await uploadCloseData();
      if (typeof callback === 'function') {
        callback();
      }
    },
    cancelOrder({ orderId }) {
      this.hasAnyAction = true;
      MgStat.send(
        'cv',
        {
          order_id: orderId,
        },
        {
          mod: 'c_hwordercancelpop',
        },
      );
      this.$message.confirm('确认取消订单?')
        .then(
          async () => {
            this.orders = []; // 取消后清空数据
            this.pageNo = 0; // 加载新的数据 因为loadMore会自动触发 自动加1
            MgStat.send(
              'click',
              {
                order_id: orderId,
              },
              {
                cont: '确定',
                direct: 'cntp',
                cntp: 'haowu_order_pay',
                mod: 'c_hwordercancelpop',
                label: 'btn',
              },
            );
            try {
              await orderApi.cancelOrder({ orderId });
              this.$toast({
                message: '取消成功',
                duration: 3000,
              });
              this.fetchOrderList();
            } catch (error) {
              this.$toast({
                message: `取消失败：${error.message}`,
                duration: 3000,
              });
            }
          },
          () => {
            MgStat.send(
              'click',
              {
                order_id: orderId,
              },
              {
                direct: 'cntp',
                cntp: 'haowu_order_pay',
                mod: 'c_hwordercancelpop',
                cont: '取消',
                label: 'btn',
              },
            );
          },
        );
    },
    showShipping(val) {
      return Number(val);
    },
    async gotoPay({
      orderAmount, orderId, orderStatusCode, promId, promType, storeId,
    }) {
      this.hasAnyAction = true;
      this.orderId = orderId;
      this.oldOrderId = null;
      if (isNotPayEndPrice(orderStatusCode)) {
        try {
          const newId = await orderApi.submitRetainageOrder({ orderId });
          this.oldOrderId = orderId;
          this.orderId = newId;
        } catch (error) {
          this.$toast(`支付调起失败：${error.message}`);
          return;
        }
      }
      if (promType === 8) {
        // 众筹需要上报众筹id
        this.crowdId = promId;
      } else {
        this.crowdId = null;
      }
      this.payStoreId = storeId;
      this.payCode = ''; // 新的订单 支付方式不限定
      this.orderPrice = orderAmount;
      this.isShowPay = true;
    },
    gotoExpress(item, deliveryId) {
      const { orderId, orderGoodsList } = item;
      let del_id = deliveryId;

      if (!deliveryId) {
        const [val] = orderGoodsList;
        del_id = val.deliveryId;
      }
      beforeRouteChange(
        {
          path: '/express',
          query: {
            orderId,
            deliveryId: del_id,
          },
        },
        this,
      );
    },
    async confirmOrder({ orderId }) {
      this.hasAnyAction = true;
      this.$message.confirm('确认收货?')
        .then(async () => {
          try {
            await orderApi.confirmOrder({ orderId });
            this.$toast({
              message: '操作成功',
              duration: 2000,
            });
            this.changeNowType('WAITCCOMMENT');
          } catch (error) {
            this.$toast(`操作失败:${error.message}`, 3000);
          }
        });
    },
    gotoComment({ orderId: id }) {
      beforeRouteChange({
        path: '/comment',
        query: { id },
      }, this);
    },
    getOptButton(item) {
      const {
        orderStatusCode: type, orderGoodsList, promType, storeId,
      } = item;
      if (_.isEmpty(orderGoodsList)) {
        return;
      }
      const [val] = orderGoodsList;
      const { deliveryId } = val;
      const showAllDel = orderGoodsList.every(f => f.deliveryId === deliveryId); // 每个商品物流订单一样 才显示查看物流(总的)
      const showReceive = orderGoodsList.every(f => f.deliveryId !== 0);
      const {
        gotoDetail,
        cancelOrder,
        gotoPay,
        gotoExpress,
        confirmOrder,
        gotoComment,
      } = this;
      const result = [
        {
          title: '查看订单',
          method: gotoDetail,
        },
      ];
      if (type === 'WAITPAY') {
        if (storeId !== 97) {
          result.push(
            {
              title: '取消订单',
              method: cancelOrder,
            },
            {
              title: '付款',
              method: gotoPay,
            },
          );
        } else {
          result.push({
            title: '付款',
            method: gotoPay,
          });
        }
      }
      if (type === 'WAITRECEIVE') {
        if (showAllDel) {
          result.push(
            {
              title: '查看物流',
              method: gotoExpress,
            },
            {
              title: '确认收货',
              method: confirmOrder,
            },
          );
        } else if (showReceive) {
          result.push({
            title: '确认收货',
            method: confirmOrder,
          });
        }
      } else if (type === 'WAITCCOMMENT') {
        if (showAllDel && promType !== 5) {
          result.push(
            {
              title: '查看物流',
              method: gotoExpress,
            },
            {
              title: '评价',
              method: gotoComment,
            },
          );
        } else {
          result.push({
            title: '评价',
            method: gotoComment,
          });
        }
      } else if (type === 'FINISH' && showAllDel && promType !== 5) {
        result.push({
          title: '查看物流',
          method: gotoExpress,
        });
      }
      return result;
    },
    /* 页面初始化会自动执行一次 */
    async loadMore() {
      this.isChangeType = false;
      if (this.disableLoad) {
        return;
      }
      this.pageNo += 1;
      const userInfo = getMgtvUserTicket();
      if (!(userInfo && userInfo.ticket)) {
        await setAsyncUserInfo();
      }
      this.fetchOrderList();
    },
    async fetchOrderList() {
      this.loading = true;
      const {
        nowType, pageNo, isChangeType, fromJifen,
      } = this;
      try {
        let data;
        if (this.fromJubaopen) {
          data = await orderApi.getUserOrderJbpList({
            type: nowType,
            p: pageNo,
          });
        } else {
          data = await orderApi.getUserOrderList({
            storeId: fromJifen ? 97 : 0,
            type: nowType,
            p: pageNo,
          });
        }
        if (data && Array.isArray(data.records)) {
          const { records } = data;
          if (isChangeType) {
            this.orders = records;
          } else {
            this.orders.push(...records);
            if (!records.length) {
              this.disableLoad = true;
            }
          }
        }
      } catch (error) {
        // this.$toast(`${error.message}`);
      }
      this.loading = false;
    },
    changeNowType(type) {
      this.hasAnyAction = true;
      this.nowType = type;
      this.pageNo = 1;
      this.isChangeType = true;
      this.disableLoad = false;
      this.fetchOrderList();
      const lastPageName = DataStorage.getPrePage();
      this.$router.replace({
        path: '/order/all',
        query: {
          type,
          lastp: lastPageName,
          from: this.$route.query.from || '',
        },
      });
      /* 安卓端 页面刷新 title就会变化 所以在此需要再执行一遍 */
      MgtvApi.setWebviewTitle({
        title: this.fromJifen ? '兑换记录' : '我的订单',
      });
    },
    gotoDetail({ orderId }) {
      beforeRouteChange({
        path: '/order/detail',
        query: { id: orderId },
      }, this);
    },
    getOrderAmount(val) {
      if (val.integral) {
        if (Number(val.orderAmount)) {
          return `¥${val.orderAmount}+${val.integral}${this.coinName}`;
        }
        return `${val.integral}${this.coinName}`;
      }
      return `¥ ${val.orderAmount}`;
    },
    getGoodsPrice(ele) {
      if (ele.exchangeIntegral) {
        if (Number(ele.exchangePrice)) {
          return `¥${ele.exchangePrice}+${ele.exchangeIntegral}${this.coinName}`;
        }
        return `${ele.exchangeIntegral}${this.coinName}`;
      }
      return `¥ ${ele.goodsPrice}`;
    },
    // 共计多少件商品
    countGoodsNum(item) {
      let count = 0;
      if (item && item.orderGoodsList) {
        item.orderGoodsList.forEach((element) => {
          count += element.goodsNum;
        });
      }
      return count;
    },
    gotoReturnInfo({
      isApplyRefund, refundId, refundStatus,
    }) {
      this.cancelBubble();
      if (isApplyRefund && refundId && refundStatus >= -1) {
        this.$router.push({ path: '/refund/detail', query: { id: refundId } });
      }
    },
    cancelBubble(e) {
      const evt = e || window.event;
      if (evt.stopPropagation) { // W3C
        evt.stopPropagation();
      } else { // IE
        evt.cancelBubble = true;
      }
    },
  },
  beforeDestroy() {
    hideMessageBox();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.hasRouteChange) {
      uploadCloseData();
    }
    next();
  },
};
</script>

<style lang="scss">
.order {
  height: 100%;
  box-sizing: border-box;

  &__main {
    height: 100%;
    position: relative;
  }

  &__nav {
    position: absolute;
    z-index: 1000;
    border-top: 2px solid rgba(211, 211, 211, 0.5);
    border-bottom: 2px solid rgba(211, 211, 211, 0.5);
    top: 0;
    left: 0;
    right: 0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 30px;
    font-size: 24px;
    color: #000000;

    div {
      width: 86px;
      height: 70px;
      line-height: 70px;
      box-sizing: border-box;
      text-align: center;
    }
  }

  &__checked-nav {
    border-bottom: 4px solid #ff5f00;
  }

  &__presell {
    &-logo {
      margin: 10px 0;
    }

    &-buy {
      padding-bottom: 20px;
      text-align: right;
    }
  }

  &__content {
    height: 100%;
    box-sizing: border-box;
    padding-top: 70px;

    &-goods{
      z-index:100;
    }

    &-background {
      height: 329px;
      margin: 70px auto;
      display: -webkit-box;
    }

    &-item {
      margin: 30px;
      padding: 0 26px;
      background: #fff;
      border-radius: 20px;
    }

    &-ordersn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24px;
      padding: 18px 0;

      :first-child {
        color: #4a4a4a;
      }

      :last-child {
        color: #ff5f00;
      }
    }

    &-price {
      display: flex;
      height: 80px;
      line-height: 80px;
      font-size: 28px;
      color: #000000;
      justify-content: flex-end;

      span + span {
        margin-left: 20px;
      }
    }

    &-buy {
      border-top: 2px solid rgba(211, 211, 211, 0.5);
      display: flex;
      justify-content: flex-end;
      height: 80px;
      align-items: center;
      justify-content: flex-end;
      color: #000000;
    }

    .opt-button {
      font-size: 24px;
      border: 1px solid #9b9b9b;
      border-radius: 20px;
      padding: 0px 20px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      margin-left: 26px;
      margin-top: 20px;
    }

    &-sku {
      display: flex;
      padding: 20px 0;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);
    }

    &-skuimg {
      img {
        width: 150px;
        height: 150px;
      }
    }

    &-skuinfo {
      margin-left: 26px;
      font-size: 22px;
      flex: 1;

      section {
        display: flex;
        font-size: 26px;
        color: #000000;
        margin-bottom: 10px;

        p:first-child {
          word-break: break-all;
          width: 300px;
          //margin-right: 28px;
        }

        p:last-child {
          flex: 1;
        }
      }

      section:nth-of-type(2) {
        display: flex;
        font-size: 24px;
        z-index: 1000;

        p:first-child {
          margin-top: 20px;
          color: #ff5f00;
        }

        p:last-child {
          color: #999999;
          flex: 1;
        }
      }

      section:nth-of-type(3) {
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .pay_class {
    border: 1px solid #ff6002 !important;
    color: #ff6002;
  }
}
</style>

